import { isMobile, isIOS, isAndroid } from 'react-device-detect'
import { Elements } from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js'
import { DisplayProvider } from '@context/DisplayContext/DisplayContext'
import { AuthProvider } from '@context/AuthContext/AuthContext'
import { CausesProvider } from '@context/CausesContext/CausesContext'
import { OrganizationProvider } from '@context/OrganizationContext/OrganizationContext'
import { StripeProvider } from '@context/StripeContext/StripeContext'
import { LoadingProvider } from '@context/LoadingContext/LoadingContext'
import type {
  MobileRedirectResult,
  ProviderWrapperProps,
} from '@Interfaces/Config/SetupInterface'
import React from 'react'

/**
 * Handle mobile redirect to app stores
 * @returns 'redirected' if redirect occurred, 'continue' otherwise
 */
export function handleMobileRedirect(): MobileRedirectResult {
  const path = window.location.pathname
  if (isMobile && (isIOS || isAndroid) && path.includes('appstore')) {
    if (isIOS) {
      window.location.href = 'https://apps.apple.com/us/app/rayze/id1615610467'
    } else {
      window.location.href = 'https://play.google.com/store/apps/details?id=com.rayze'
    }
    return 'redirected'
  }
  return 'continue'
}

/**
 * Provider wrapper component that sets up all app providers
 */
export const AppProviders: React.FC<ProviderWrapperProps> = ({
  children,
  stripePublishableKey,
}) => {
  const stripePromise = loadStripe(stripePublishableKey)

  return (
    <Elements stripe={stripePromise}>
      <DisplayProvider>
        <AuthProvider>
          <CausesProvider>
            <OrganizationProvider>
              <StripeProvider>
                <LoadingProvider>{children}</LoadingProvider>
              </StripeProvider>
            </OrganizationProvider>
          </CausesProvider>
        </AuthProvider>
      </DisplayProvider>
    </Elements>
  )
}
